<script setup>
import { useI18n } from 'vue-i18n';
import Spinner from 'shared/components/Spinner.vue';

defineProps({
  snapshot: {
    type: Object,
    default: () => ({ open: 0, pending: 0, snoozed: 0, resolved_today: 0 }),
  },
  loading: { type: Boolean, default: false },
});

const { t } = useI18n();

const metrics = [
  { key: 'open', color: 'text-n-blue-11', bg: 'bg-n-blue-3' },
  { key: 'pending', color: 'text-n-amber-11', bg: 'bg-n-amber-3' },
  { key: 'snoozed', color: 'text-n-slate-11', bg: 'bg-n-slate-3' },
  { key: 'resolved_today', color: 'text-n-teal-11', bg: 'bg-n-teal-3' },
];
</script>

<template>
  <div class="flex flex-col rounded-xl shadow outline-1 outline outline-n-container bg-n-solid-2 px-6 py-5">
    <h3 class="mb-4 text-sm font-medium text-n-slate-11 uppercase tracking-wider">
      {{ t('CEO_DASHBOARD.SNAPSHOT.HEADER') }}
    </h3>
    <div v-if="loading" class="flex items-center justify-center py-4">
      <Spinner />
    </div>
    <div v-else class="grid grid-cols-2 gap-4 md:grid-cols-4">
      <div
        v-for="metric in metrics"
        :key="metric.key"
        class="flex flex-col items-center gap-1 rounded-lg py-3"
        :class="metric.bg"
      >
        <span class="text-2xl font-bold" :class="metric.color">
          {{ snapshot[metric.key]?.toLocaleString() || 0 }}
        </span>
        <span class="text-xs font-medium" :class="metric.color">
          {{ t(`CEO_DASHBOARD.SNAPSHOT.${metric.key.toUpperCase()}`) }}
        </span>
      </div>
    </div>
  </div>
</template>
